import {useTranslation} from 'react-i18next';

import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import {Box, Typography} from '@mui/material';

import {WorkforceProfileWizardSelectableCard} from './WorkforceProfileWizardSelectableCard';
import {accent, neutral} from '../../../../../layouts/theme/designSystem';
import type {WorkforceProfileInputMode} from '../../types/workforceProfileWizardTypes';

export interface Props {
  onSelect: (mode: WorkforceProfileInputMode) => void;
}

export const WorkforceProfileCreatePathChoice = ({onSelect}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.pathChoice'});

  const pathIconSx = {color: accent.icon, fontSize: 32};

  const containerSx = {
    display: 'flex',
    flexDirection: {xs: 'column', sm: 'row'},
    alignItems: 'stretch',
    gap: {xs: 2, sm: 2},
    mt: 1,
  };

  const dividerContainerSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: {xs: 0, sm: 0.5},
    py: {xs: 0.5, sm: 0},
  };

  const dividerTextSx = {color: neutral[600], fontWeight: 700, letterSpacing: 1.2};

  return (
    <Box sx={containerSx}>
      <WorkforceProfileWizardSelectableCard
        icon={<UploadFileOutlinedIcon sx={pathIconSx} />}
        title={t('uploadTitle')}
        description={t('uploadDescription')}
        selectLabel={t('select')}
        onSelect={() => onSelect('document')}
      />

      <Box sx={dividerContainerSx}>
        <Typography variant='overline' sx={dividerTextSx}>
          {t('or')}
        </Typography>
      </Box>

      <WorkforceProfileWizardSelectableCard
        icon={<EditNoteOutlinedIcon sx={pathIconSx} />}
        title={t('guidedTitle')}
        description={t('guidedDescription')}
        selectLabel={t('select')}
        onSelect={() => onSelect('guided')}
      />
    </Box>
  );
};
